export function Logo({ className = "h-9", boxed = true }) {
  const img = (
    <img
      src="/arrow-logo.webp?v=2"
      alt="Arrow International Packers & Movers"
      className={className}
      data-testid="arrow-logo"
    />
  );
  if (!boxed) return img;
  return <div className="bg-white rounded-sm px-2.5 py-1.5 inline-flex items-center">{img}</div>;
}
